import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function Paragraph({ image, name, paragraphs }) {
  if (!paragraphs || paragraphs.length === 0) return null; // Ensures there are paragraphs to process
  const shouldHideHr = /Adam/i.test(name);
  const shouldAddBreak = name && name.includes("Denise");

  return (
    <Container className="instructor-container">
      {shouldAddBreak && <br />}
      <Row>
        <Col md={3} sm={12} xs={12}>
          <div className="instructor-div">
            <img className="instructor-image about-us-image" src={image} alt={name} style={{ width: '178px', height: 'auto' }} />
            <div className="instructor-name">{name}</div>
          </div>
        </Col>
        <Col md={9} sm={12} xs={12}>
          <div style={{ fontSize: "18px", textAlign: "left" }}>{paragraphs}</div>
        </Col>
      </Row>
      {!shouldHideHr && <div><hr className="about-hr" /></div>}
      {shouldHideHr && <br />}
    </Container>
  );
}


